export enum TipoEmissaoEnum {
    EmissaoPresencial = 1,
    EmissaoPresencialDescription = 'Emissão presencial',
    RenovacaoOnline = 2,
    RenovacaoOnlineDescription = 'Renovação on-line',
    EmissaoVideoconferencia = 3,
    EmissaoVideoconferenciaDescription = 'Emissão videoconferência',
    EmissaoAutonoma = 4,
    EmissaoAutonomaDescription = 'Emissão autônoma',
    EmissãoOnline = 5,
    EmissãoOnlineDescription = 'Emissão on-line',
}